export const BRAND = {
  name: 'Abriola Propiedades',
  years: 34,
  address: 'Av. Rodolfo A. López 818, Quilmes, Buenos Aires',
  phoneVentas: '+54 11 6372-3335',
  waVentas: import.meta.env.VITE_WA_VENTAS || '5491163723335',
  phoneAlquileres: '+54 11 2587-1598',
  waAlquileres: import.meta.env.VITE_WA_ALQUILERES || '5491125871598',
  email: import.meta.env.VITE_CONTACT_EMAIL || 'info@abriolapropiedades.com.ar',
  instagram: 'https://www.instagram.com/abriola.propiedades/',
  facebook: 'https://www.facebook.com/abriolapropiedadesquilmes/',
  colegio: 'Colegio de Martilleros y Corredores Públicos de Quilmes',
  hours: 'Lun a Vie 9 a 18 h · Sáb 9 a 13 h',
};

export const PROP_TYPES = {
  departamento: 'Departamento',
  casa: 'Casa',
  ph: 'PH',
  terreno: 'Terreno',
  local: 'Local',
  galpon: 'Galpón',
  cochera: 'Cochera',
  oficina: 'Oficina',
};

export const OP_TYPES = {
  venta: 'Venta',
  alquiler: 'Alquiler',
};

export const STATUS = {
  pozo: 'En pozo',
  nuevo: 'A estrenar',
  usado: 'Usado',
};

// Tokko property_type IDs (confirmados con Tokko)
export const TOKKO_TYPE_MAP = {
  2:  'departamento',
  3:  'casa',
  13: 'ph',
  5:  'terreno',
  7:  'local',
  8:  'oficina',
  14: 'galpon',
  16: 'cochera',
};

// Tokko operation_type IDs
export const TOKKO_OP_MAP = {
  1: 'venta',
  2: 'alquiler',
  3: 'pozo',
};

export const SORTS = [
  { value: 'relevancia', label: 'Relevancia' },
  { value: 'price_asc',  label: 'Menor precio' },
  { value: 'price_desc', label: 'Mayor precio' },
  { value: 'newest',     label: 'Más recientes' },
];

export const ZONAS = [
  { slug: 'quilmes',       name: 'Quilmes',       tokkoId: null },
  { slug: 'bernal',        name: 'Bernal',        tokkoId: null },
  { slug: 'don-bosco',     name: 'Don Bosco',     tokkoId: null },
  { slug: 'wilde',         name: 'Wilde',         tokkoId: null },
  { slug: 'quilmes-oeste', name: 'Quilmes Oeste', tokkoId: null },
  { slug: 'avellaneda',    name: 'Avellaneda',    tokkoId: null },
];
